import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { Endpoint } from '../constants/endpoint';

import {
  DatasetByCriteriaRequestModel,
  DatasetByCriteriaResponseModel,
} from '../../models/dataset.model';

import { TransformTool } from '../tools/transform.tool';

@Injectable({
  providedIn: 'root',
})
export class DatasetFetchService {
  constructor(private httpClient: HttpClient) {}

  public dataset(
    query: DatasetByCriteriaRequestModel
  ): Observable<DatasetByCriteriaResponseModel> {
    return this.httpClient.get<DatasetByCriteriaResponseModel>(
      `${
        Endpoint.Customer.Metabase.Dataset
      }${TransformTool.ConvertObjectToQueryString(query)}`
    );
  }
}
